import { render, staticRenderFns } from "./ed-date-picker.component.vue?vue&type=template&id=136db0b0&scoped=true&"
import script from "./ed-date-picker.component.ts?vue&type=script&lang=ts&"
export * from "./ed-date-picker.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-date-picker.component.scss?vue&type=style&index=0&id=136db0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136db0b0",
  null
  
)

export default component.exports